import React from 'react';
import Icon from '../../../components/AppIcon';

const AdminSidebar = ({ activeSection, onSectionChange, isOpen, setIsOpen }) => {
  const menuItems = [
    {
      id: 'dashboard',
      name: 'Dashboard',
      icon: 'BarChart3',
      description: 'Overview & Analytics'
    },
    {
      id: 'homepage',
      name: 'Homepage',
      icon: 'Home',
      description: 'Hero section & slideshow'
    },
    {
      id: 'services',
      name: 'Services',
      icon: 'Users',
      description: 'Manage all services'
    },
    {
      id: 'projects',
      name: 'Projects',
      icon: 'FolderOpen',
      description: 'Portfolio management'
    },
    {
      id: 'testimonials',
      name: 'Testimonials',
      icon: 'Star',
      description: 'Client feedback & reviews'
    },
    {
      id: 'blog',
      name: 'Blog & Articles',
      icon: 'FileText',
      description: 'Content management'
    },
    {
      id: 'team',
      name: 'Team',
      icon: 'Users',
      description: 'Team member profiles'
    },
    {
      id: 'calculators',
      name: 'Calculators',
      icon: 'Calculator',
      description: 'Interactive tools & formulas'
    },
    {
      id: 'settings',
      name: 'Settings',
      icon: 'Settings',
      description: 'Site configuration'
    }
  ];

  return (
    <>
      <div
        className={`
          fixed top-0 left-0 bottom-0 z-[60] lg:z-40 w-64 bg-card border-r border-border overflow-y-auto transition-transform duration-300 ease-in-out shadow-2xl lg:shadow-none
          ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
          lg:static lg:h-full
        `}
      >
        {/* Logo - Desktop Only */}
        <div className="p-6 border-b border-border hidden lg:block h-16 flex items-center">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 flex items-center justify-center overflow-hidden">
              <img src="/favicon.ico" alt="Logo" className="w-full h-full object-contain" />
            </div>
            <div>
              <h1 className="text-lg font-bold text-foreground leading-none">Nirmitee</h1>
              <p className="text-[10px] text-muted-foreground leading-none mt-1">Admin Panel</p>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="p-4 space-y-1">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => onSectionChange(item.id)}
              className={`w-full flex items-center space-x-3 px-3 py-3 rounded-lg text-left transition-all duration-200 group ${activeSection === item.id
                ? 'bg-primary/10 text-primary border-r-2 border-primary ring-1 ring-primary/5'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                }`}
            >
              <Icon
                name={item.icon}
                size={20}
                className={activeSection === item.id ? 'text-primary' : 'text-muted-foreground group-hover:text-foreground'}
              />
              <div className="flex-1">
                <div className="font-medium text-sm">{item.name}</div>
                <div className={`text-[10px] ${activeSection === item.id ? 'text-primary/70' : 'text-muted-foreground/70'}`}>{item.description}</div>
              </div>
              {activeSection === item.id && (
                <Icon name="ChevronRight" size={14} className="text-primary opacity-50" />
              )}
            </button>
          ))}
        </nav>

        {/* Footer info/version */}
        <div className="p-4 mt-auto border-t border-border">
          <div className="text-xs text-muted-foreground text-center">
            <p>Version 1.0.0</p>
            <p>&copy; 2026 Nirmitee Associates</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminSidebar; 